import React, {createContext, useContext, ReactNode} from "react"

interface StoreContextType {
  schemeType: "home_and_electronics" | "cycle_to_work"
  schemeName: "Home and Electronics" | "Cycle to Work"
}

const StoreContext = createContext<StoreContextType | undefined>(undefined)

export const StoreProvider = ({children}: {children: ReactNode}) => {
  const isHE = window.location.pathname.includes("home_and_electronics")

  return (
    <StoreContext.Provider
      value={{
        schemeType: isHE ? "home_and_electronics" : "cycle_to_work",
        schemeName: isHE ? "Home and Electronics" : "Cycle to Work"
      }}>
      {children}
    </StoreContext.Provider>
  )
}

export const useStoreContext = () => {
  const context = useContext(StoreContext)
  if (context === undefined) {
    throw new Error("useStoreContext must be used within a StoreProvider")
  }
  return context
}
